// @flow
// @flow-runtime warn
import { createContext } from 'react'

import { type SubsidyOrders } from './SubsidyOrdersTypes'


export const defaultSubsidyOrders = {}

type ContentType = {
  subsidyOrders: SubsidyOrders,
}

const defaultContent: ContentType = {
  subsidyOrders: defaultSubsidyOrders,
}

type LoadingType = {
  subsidyOrders: boolean,
}

const defaultLoading: LoadingType = {
  subsidyOrders: true,
}

type RequestsType = {
  subsidyOrders: () => Promise<void> | void,
}

const defaultRequests = {
  subsidyOrders: () => {},
}

type SubsidyOrdersContextType = {
  content: ContentType,
  loading: LoadingType,
  request: RequestsType,
}

const defaultContext: SubsidyOrdersContextType = {
  content: defaultContent,
  loading: defaultLoading,
  request: defaultRequests,
}

export default createContext<SubsidyOrdersContextType>(defaultContext)
